module.exports = __webpack_public_path__ + "img/NewEmployee.5b488940.svg";